import Flowchart from "@/modules/flowcharts/flowchart-layout"
import FlowchartRouter from "@/modules/flowcharts/flowchart-router"
import SavDoc from "@/modules/flowcharts/flowchart-saved-components"

const FlowChartRouter = {
	path: "/flowchart",
	name: "flowchart",
	component: FlowchartRouter,
	children: [
		{
			path: "",
			name: "documents.flowchart",
			component: Flowchart
		},
		{
			path: "editsaved",
			name: "documents.flowchart-editsaved",
			component: SavDoc
		},
		{
			path: ":folder_id",
			name: "documents.flowchartedit.folder_id",
			component: Flowchart,
			props: true
		}
	]
}

export default FlowChartRouter
